import { useEffect } from "react";

const PaymentRoute = () => {
  useEffect(() => {
    try {
      if (window.opener) {
        window.opener.postMessage({ type: "stripe_payment_complete" }, window.location.origin);
        window.close();
      } else {
        window.location.replace("/");
      }
    } catch (e) {
      window.location.replace("/");
    }
  }, []);

  return null;
};

export default PaymentRoute;
